import React, { useState, useRef, useContext } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AddTemplate from "./AddTemplateForm";
import { MenuItem, FormControl, InputLabel, Select } from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import Switch from "@mui/material/Switch";
import SimpleBackdrop from "../../Components/Backdrop";
import Formula from "../../Components/Formula";
import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../../Layout";
import { useEffect } from "react";
import { changeIDFormula } from "./FormUpdateQuestion";
import { APIServices } from "./../../helpers/APIServices";
import TemplateEdit from "./TemplateEdit";

const labelCheckbox = { inputProps: { "aria-label": "Checkbox demo" } };

const label = { inputProps: { "aria-label": "Switch demo" } };

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export const searchPartID = (url) => {
  if (typeof url !== "string") {
    throw Error("url should be type string").stack;
  }
  const arr = url.split("/");
  return arr[4];
};

function FormAddQuestionTemplate({
  subCat,
  setOpen,
  open,
  setSuccess,
  subCategory,
  category,
  partName,
  partCode,
}) {
  const location = useLocation();
  const partId = searchPartID(location.pathname);
  const [revise, setRevise] = useState(false);
  const [revisionRecord, setRevisionRecord] = useState("");
  const [part, setPart] = useState("");
  const user = useContext(UserContext);
  const [question, setQuestion] = useState();
  const [specMin, setSpecMin] = useState();
  const [specMax, setSpecMax] = useState();
  const [inspectionTool, setInspectionTool] = useState();
  const [remark, setRemark] = useState();
  const [UCL_Xbar, setUCL_Xbar] = useState();
  const [CL_Xbar, setCL_Xbar] = useState();
  const [LCL_Xbar, setLCL_Xbar] = useState();
  const [UCL_Rchart, setUCL_Rchart] = useState();
  const [CL_Rchart, setCL_Rchart] = useState();
  const [LCL_Rchart, setLCL_Rchart] = useState();
  const [template, setTemplate] = useState("");
  const [templates, setTemplates] = useState("");
  const [openEditTemplate, setOpenEditTemplate] = useState(false);
  const [openAddTemplate, setOpenAddTemplate] = useState(false);
  const navigate = useNavigate();
  const [imageQuestion, setImageQuestion] = useState("");
  const [alert, setAlert] = React.useState({
    open: false,
    type: "info",
    massage: "",
  });
  const [isSC, setIsSC] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMinMax, setErrorMinMax] = useState(false);
  const [shouldRefetch, setShouldRefetch] = useState(false);

  const switchRef = useRef();
  const questionRef = useRef();
  const specMinRef = useRef();
  const specMaxRef = useRef();
  const remarkRef = useRef();
  const inspectionToolRef = useRef();
  const UCL_xBarRef = useRef();
  const CL_xBarRef = useRef();
  const LCL_xBarRef = useRef();
  const UCL_rChartRef = useRef();
  const CL_rChartRef = useRef();
  const LCL_rChartRef = useRef();

  const [formula, setFormula] = useState();

  const checkError = () => {
    if (specMinRef.current) {
      setErrorMinMax(
        parseFloat(specMin) > parseFloat(specMax) ||
          parseFloat(specMin) === parseFloat(specMax)
      );
    }
  };
  const fetchTemplates = async () => {
    try {
      const response = await APIServices.getAllTemplate();
      console.log(response.data.data);
      setTemplates(response.data.data);
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  };
  const handleChangeTemplate = (event) => {
    const selectId = event.target.value;
    const select = templates.find((e) => e.id === selectId);
    setTemplate(select);
  };

  const handleOpenEditTemplate = () => {
    setOpenEditTemplate(true);
  };

  const handleOpenAddTemplate = () => {
    setOpenAddTemplate(true);
  };

  const handleChangeQuestion = (e) => {
    setQuestion(e.target.value);
  };
  const handleChangeSpecMin = (e) => {
    setSpecMin(e.target.value);
  };
  const handleChangeSpecMax = (e) => {
    setSpecMax(e.target.value);
  };
  const handleChangeInspectionTool = (e) => {
    setInspectionTool(e.target.value);
  };
  const handleChangeRemark = (e) => {
    setRemark(e.target.value);
  };

  const hanldeChangeUclXbar = (e) => {
    setUCL_Xbar(e.target.value);
  };

  const handleChnageLclXbar = (e) => {
    setLCL_Xbar(e.target.value);
  };
  const hanldeChangeClXbar = (e) => {
    setCL_Xbar(e.target.value);
  };

  const hanldeChangeUclRchart = (e) => {
    setUCL_Rchart(e.target.value);
  };

  const hanldeChangeClRchart = (e) => {
    setCL_Rchart(e.target.value);
  };

  const handleChangeLclRchart = (e) => {
    setLCL_Rchart(e.target.value);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseAlert = () => {
    setAlert((data) => ({ ...data, open: false }));
  };

  const findOnePart = async () => {
    console.log("use api");
    const findPart = await APIServices.findOnePartForFromAddQuestion(partId);
    const partData = findPart.data.data;
    setPart({
      id: partData.id,
      ...partData.attributes,
    });
  };

  const createQuestion = async (
    image,
    specMin,
    specMax,
    sc_status,
    question,
    remark,
    inspectionTool,
    UCL_xBar,
    CL_xBar,
    LCL_xBar,
    UCL_rChart,
    CL_rChart,
    LCL_rChart,
    subCategory,
    formula
  ) => {
    const signature =
      user.signature !== null
        ? user.signature[user.signature.length - 1].url
        : "";
    if (question === "") {
      setAlert({
        open: true,
        type: "error",
        massage: "ไม่มีข้อมูลคำถาม",
      });
      return;
    }
    // if (part.papers.data.length > 0 && revise === false) {
    //   setAlert({
    //     open: true,
    //     type: "error",
    //     massage: "พาร์ทนี้มีการเพิ่ม paper กรุณาทำการกด revise",
    //   });
    //   return;
    // }
    // if (checkFormulaError(formula)) {
    //   setAlert({
    //     open: true,
    //     type: "error",
    //     massage: "รูปแบบสูตรของคุณผิด !!!",
    //   });
    //   return;
    // }
    if (revise === false) {
      if (question === "") {
        setAlert({
          open: true,
          type: "error",
          massage: "ยังไม่ได้ทำการเพิ่มคำถาม",
        });
      } else {
        setLoading(true);
        const response = await APIServices.createQuestion(
          specMin,
          specMax,
          sc_status,
          question,
          remark,
          inspectionTool,
          UCL_xBar,
          CL_xBar,
          LCL_xBar,
          UCL_rChart,
          CL_rChart,
          LCL_rChart,
          subCategory,
          true,
          formula,
          "1",
          part.revise_time
        );

        if (response.data.data !== null) {
          if (image !== undefined) {
            const formData = new FormData();
            formData.append("ref", "api::question.question");
            formData.append("refId", response.data.data.id);
            formData.append("field", "image");
            formData.append("files", image[0]);
            await APIServices.addUserImage(formData);
          }
        }

        setTimeout(() => {
          setSuccess(true);
          setLoading(false);
          setOpen(false);
          setImageQuestion({
            base: undefined,
            file: undefined,
          });
        }, 1500);
        await APIServices.getAllTemplate();
      }
    } else {
      if (revisionRecord === "" || question === "") {
        setAlert({
          open: true,
          type: "error",
          massage: "ยังไม่ได้ทำการเพิ่มคำถาม หรือเพิ่ม revision record",
        });
      } else {
        setLoading(true);
        const findPart = await APIServices.findOnePart(partId);
        const partData = findPart.data.data;
        const part = {
          id: partData.id,
          ...partData.attributes,
        };
        let partRevise;
        let keepNewData = [];
        let dataQuestionFormula = [];
        const reviseTime = part.revise_time ? part.revise_time : null;
        if (part.old_parts.data.length === 0) {
          const responseReviseForPart = await APIServices.createPartForRevise(
            part.part_name,
            part.part_code,
            reviseTime,
            part.id,
            false,
            true
          );
          partRevise = responseReviseForPart;
        } else {
          let oldPartID = [];
          part.old_parts.data.forEach((oldPart) => {
            oldPartID.push(oldPart.id);
          });
          oldPartID.push(part.id);
          const responseReviseForPart = await APIServices.createPartForRevise(
            part.part_name,
            part.part_code,
            reviseTime,
            oldPartID,
            false,
            true
          );
          partRevise = responseReviseForPart;
        }
        await APIServices.updatePart(
          part.part_name,
          part.part_code,
          part.id,
          false,
          false
        );

        const part_data = partRevise.data.data.attributes;
        const part_id = partRevise.data.data.id;

        if (part.sub_categories.data.length !== 0) {
          for (
            let indexSubCat = 0;
            indexSubCat < part.sub_categories.data.length;
            indexSubCat++
          ) {
            const subCatData = part.sub_categories.data[indexSubCat];
            const categoryID = subCatData.attributes.category.data.id;
            const subCatName = subCatData.attributes.sub_categories;
            const reviseTimeSubCat = subCatData.attributes.revise_time;
            let responseSubCat;
            if (subCatData.attributes.old_sub_categories.data.length === 0) {
              const response = await APIServices.createSubCategories(
                categoryID,
                subCatName,
                part_id,
                true,
                "0",
                reviseTimeSubCat,
                subCatData.id
              );
              responseSubCat = response;
            } else {
              let oldSubCatID = [];
              subCatData.attributes.old_sub_categories.data.forEach(
                (oldSub) => {
                  oldSubCatID.push(oldSub.id);
                }
              );
              oldSubCatID.push(subCatData.id);
              const response = await APIServices.createSubCategories(
                categoryID,
                subCatName,
                part_id,
                true,
                "0",
                reviseTimeSubCat,
                oldSubCatID
              );
              responseSubCat = response;
            }

            const realSubCatID = responseSubCat.data.data.id;

            const attributesQT = {
              spec_min: specMin,
              spec_max: specMax,
              sc_status: sc_status,
              question: question,
              UCL_Xbar: UCL_xBar,
              CL_Xbar: CL_xBar,
              LCL_Xbar: LCL_xBar,
              UCL_Rchart: UCL_rChart,
              CL_Rchart: CL_rChart,
              LCL_Rchart: LCL_rChart,
              sub_category: realSubCatID,
              status: true,
              formula: {
                data: formula,
              },
            };

            let newQuestion = subCatData.attributes.questions.data;
            if (
              subCatData.attributes.questions.data &&
              subCatData.id === subCat
            ) {
              newQuestion.push({
                attributes: attributesQT,
              });
            }

            if (newQuestion.length !== 0) {
              for (
                let indexQuestion = 0;
                indexQuestion < newQuestion.length;
                indexQuestion++
              ) {
                const realQuestion = newQuestion[indexQuestion];
                const revise_time = realQuestion.attributes.revise_time;
                const specMin = realQuestion.attributes.spec_min;
                const specMax = realQuestion.attributes.spec_max;
                const sc_status = realQuestion.attributes.sc_status;
                const question = realQuestion.attributes.question;
                const UCL_xBar = realQuestion.attributes.UCL_Xbar;
                const CL_xBar = realQuestion.attributes.CL_Xbar;
                const LCL_xBar = realQuestion.attributes.LCL_Xbar;
                const UCL_rChart = realQuestion.attributes.UCL_Rchart;
                const CL_rChart = realQuestion.attributes.CL_Rchart;
                const LCL_rChart = realQuestion.attributes.LCL_Rchart;
                const subCategory = realSubCatID;
                const status = realQuestion.attributes.status;
                const formula = realQuestion.attributes.formula
                  ? realQuestion.attributes.formula.data
                  : null;

                if (realQuestion.id) {
                  if (realQuestion.attributes.old_question.data.length === 0) {
                    const responseQuestion = await APIServices.createQuestion(
                      specMin,
                      specMax,
                      sc_status,
                      question,
                      remark,
                      inspectionTool,
                      UCL_xBar,
                      CL_xBar,
                      LCL_xBar,
                      UCL_rChart,
                      CL_rChart,
                      LCL_rChart,
                      subCategory,
                      status,
                      formula,
                      "0",
                      revise_time,
                      realQuestion.id
                    );
                    if (responseQuestion.data.data.attributes.formula.data) {
                      keepNewData.push({
                        id: responseQuestion.data.data.id,
                        formula: responseQuestion.data.data.attributes.formula,
                      });
                    }
                    dataQuestionFormula.push({
                      old_id: realQuestion.id,
                      new_id: responseQuestion.data.data.id,
                    });
                  } else {
                    let oldQuestionID = [];
                    realQuestion.attributes.old_question.data.forEach(
                      (oldQuestion) => {
                        oldQuestionID.push(oldQuestion.id);
                      }
                    );
                    oldQuestionID.push(realQuestion.id);
                    const responseQuestion = await APIServices.createQuestion(
                      specMin,
                      specMax,
                      sc_status,
                      question,
                      remark,
                      inspectionTool,
                      UCL_xBar,
                      CL_xBar,
                      LCL_xBar,
                      UCL_rChart,
                      CL_rChart,
                      LCL_rChart,
                      subCategory,
                      status,
                      formula,
                      "0",
                      revise_time,
                      oldQuestionID
                    );
                    if (responseQuestion.data.data.attributes.formula.data) {
                      keepNewData.push({
                        id: responseQuestion.data.data.id,
                        formula: responseQuestion.data.data.attributes.formula,
                      });
                    }
                    dataQuestionFormula.push({
                      old_id: realQuestion.id,
                      new_id: responseQuestion.data.data.id,
                    });
                  }
                } else {
                  const responseQuestion = await APIServices.createQuestion(
                    specMin,
                    specMax,
                    sc_status,
                    question,
                    remark,
                    inspectionTool,
                    UCL_xBar,
                    CL_xBar,
                    LCL_xBar,
                    UCL_rChart,
                    CL_rChart,
                    LCL_rChart,
                    subCategory,
                    status,
                    formula,
                    "1",
                    part_data.revise_time
                  );
                  if (responseQuestion.data.data.attributes.formula.data) {
                    keepNewData.push({
                      id: responseQuestion.data.data.id,
                      formula: responseQuestion.data.data.attributes.formula,
                    });
                  }
                  dataQuestionFormula.push({
                    old_id: realQuestion.id,
                    new_id: responseQuestion.data.data.id,
                  });
                }
              }
            }
          }
        }
        if (partRevise.data.data !== null) {
          console.log("checked");

          if (part.image.data !== null) {
            const files = await fetch(
              // "http://agrappl03.aapico.com:1339/uploads/9_FC_8_B6_E7_F948_451_A_8_CB_6_4_A821_B407339_a1915890e4.jpeg"
              `${part.image.data.attributes.url}`
            )
              .then((response) => response.blob())
              .then((blob) => {
                const myFile = new File(
                  [blob],
                  `${part.image.data.attributes.name}`,
                  {
                    type: blob.type,
                  }
                );
                return myFile;
              });

            const formData = new FormData();
            formData.append("ref", "api::qc-part.qc-part");
            formData.append("refId", part_id);
            formData.append("field", "image");
            formData.append("files", files);
            await APIServices.addUserImage(formData);
          }
        }

        if (partRevise.data.data.id !== null) {
          await APIServices.reviseForUpdate(
            revisionRecord,
            new Date(),
            signature,
            user.id,
            part_data.revise_time,
            part_id
          );
        }
        changeIDFormula(keepNewData, dataQuestionFormula);

        specMinRef.current.value = "";
        specMaxRef.current.value = "";
        switchRef.current.checked = "";
        questionRef.current.value = "";
        remarkRef.current.value = "";
        inspectionToolRef.current.value = "";
        UCL_xBarRef.current.value = "";
        CL_xBarRef.current.value = "";
        LCL_xBarRef.current.value = "";
        UCL_rChartRef.current.value = "";
        CL_rChartRef.current.value = "";
        LCL_rChartRef.current.value = "";
        setTimeout(() => {
          setOpen(false);
          setLoading(false);
          setImageQuestion({
            base: undefined,
            file: undefined,
          });
          navigate("/layout/revise");
        }, 1500);
      }
    }
  };

  const handleRefetch = () => {
    setShouldRefetch((prev) => !prev);
  };

  useEffect(() => {
    findOnePart();
  }, []);
  useEffect(() => {
    fetchTemplates();
    console.log(shouldRefetch);
  }, [shouldRefetch]);

  useEffect(() => {
    if (template && template.attributes.sc_status !== undefined) {
      setIsSC(template.attributes.sc_status);
    }
    if (template && template.attributes.question !== undefined) {
      setQuestion(template.attributes.question);
    }
    if (template && template.attributes.spec_min !== undefined) {
      setSpecMin(template.attributes.spec_min);
    }
    if (template && template.attributes.spec_max !== undefined) {
      setSpecMax(template.attributes.spec_max);
    }
    if (template && template.attributes.inspectionTool !== undefined) {
      setInspectionTool(template.attributes.inspectionTool);
    }
    if (template && template.attributes.remark !== undefined) {
      setRemark(template.attributes.remark);
    }
    if (template && template.attributes.UCL_Xbar !== undefined) {
      setUCL_Xbar(template.attributes.UCL_Xbar);
    }
    if (template && template.attributes.LCL_Xbar !== undefined) {
      setLCL_Xbar(template.attributes.LCL_Xbar);
    }
    if (template && template.attributes.CL_Xbar !== undefined) {
      setCL_Xbar(template.attributes.CL_Xbar);
    }
    if (template && template.attributes.UCL_Xbar !== undefined) {
      setLCL_Rchart(template.attributes.UCL_Xbar);
    }
    if (template && template.attributes.LCL_Xbar !== undefined) {
      setUCL_Rchart(template.attributes.LCL_Xbar);
    }
    if (template && template.attributes.CL_Xbar !== undefined) {
      setCL_Rchart(template.attributes.CL_Xbar);
    }
  }, [template, shouldRefetch]);

  return (
    <BootstrapDialog
      onClose={handleClose}
      open={open}
      maxWidth={"sm"}
      fullWidth
    >
      <SimpleBackdrop open={loading} setOpen={setLoading} />

      <div>
        <Snackbar
          open={alert.open}
          autoHideDuration={3000}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          onClose={handleCloseAlert}
        >
          <Alert
            onClose={handleCloseAlert}
            severity={alert.type}
            sx={{ width: "100%" }}
          >
            {alert.massage}
          </Alert>
        </Snackbar>
      </div>
      <Box
        sx={{ position: "relative", overflow: "visible", cursor: "pointer" }}
      >
        <DialogContent dividers sx={{ overflow: "visible", height: "auto" }}>
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": {
                width: "100%",
                mt: 2,
              },
            }}
            noValidate
            autoComplete="off"
          >
            <div className="flex flex-col ">
              <div className={`flex flex-row justify-center items-start mb-2`}>
                <div className={`flex flex-row relative items-baseline mb-2 `}>
                  <div
                    className="mx-1 cursor-pointer"
                    onClick={handleOpenAddTemplate}
                  >
                    {" "}
                    <AddCircleIcon
                      sx={{
                        position: "relative ",
                        alignItems: "baseline",
                        color: "blue",
                        cursor: "pointer",
                      }}
                      fontSize="large"
                    />
                  </div>

                  <FormControl variant="standard" sx={{ m: 1, width: "20vw" }}>
                    <InputLabel id="demo-simple-select-standard-label">
                      แบบฟอร์มคำถาม
                    </InputLabel>
                    <Select
                      value={template ? template.id : ""}
                      onChange={handleChangeTemplate}
                      label="Template"
                    >
                      {templates &&
                        templates.map((template) => (
                          <MenuItem key={template.id} value={template.id}>
                            {template.attributes.question}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </div>
                <div>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={handleOpenEditTemplate}
                    sx={{ marginX: "2px", justifyItems: "center" }}
                  >
                    แก้ไข แบบคำถาม
                  </Button>
                </div>
              </div>

              <div className="flex flex-row">
                <div className="basis-1/4 flex flex-row justify-center items-center m-1">
                  <span>SC</span>
                  <Switch
                    inputRef={switchRef}
                    checked={isSC}
                    {...label}
                    onChange={(e) => setIsSC(e.target.checked)}
                  />
                </div>
                <div className="m-1 basis-3/4 flex items-center ">
                  <TextField
                    // inputRef={questionRef}
                    value={question}
                    onChange={handleChangeQuestion}
                    label="คำถาม"
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
              </div>

              <div className="flex gap-4">
                <div className="basis-1/2">
                  <TextField
                    onWheel={(event) => event.target.blur()}
                    fullWidth
                    type={"number"}
                    onBlur={() => checkError()}
                    inputRef={specMinRef}
                    value={specMin}
                    onChange={handleChangeSpecMin}
                    InputLabelProps={{ shrink: true }}
                    label="min"
                    error={errorMinMax}
                    helperText={
                      errorMinMax && "มีค่ามากกว่าหรือเท่ากับ Spec Max"
                    }
                  />
                </div>
                <div className="basis-1/2">
                  <TextField
                    onWheel={(event) => event.target.blur()}
                    type={"number"}
                    onBlur={() => checkError()}
                    value={specMax}
                    onChange={handleChangeSpecMax}
                    label="max"
                    error={errorMinMax}
                    InputLabelProps={{ shrink: true }}
                    helperText={
                      errorMinMax && "มีค่าน้อยกว่าหรือเท่ากับ Spec Min "
                    }
                  />
                </div>
              </div>
              <div className="flex w-full items-center ">
                <TextField
                  // inputRef={inspectionToolRef}
                  value={inspectionTool}
                  label="Inspection Tool"
                  onChange={handleChangeInspectionTool}
                  InputLabelProps={{ shrink: true }}
                />
              </div>
              <div className="flex w-full items-center ">
                <TextField
                  inputRef={remarkRef}
                  value={remark}
                  onChange={handleChangeRemark}
                  label="หมายเหตุ"
                  InputLabelProps={{ shrink: true }}
                />
              </div>
              {/* {isSC && (
              <> */}
              <div className="flex flex-col mt-2">
                <span className="mt-2  font-semibold">X-bar</span>
                <div className="flex flex-row">
                  <div className="m-1">
                    <TextField
                      disabled={!isSC}
                      inputRef={UCL_xBarRef}
                      value={UCL_Xbar}
                      onChange={hanldeChangeUclXbar}
                      label="UCL"
                      type="number"
                      onWheel={(event) => event.target.blur()}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                  <div className="m-1">
                    <TextField
                      disabled={!isSC}
                      value={CL_Xbar}
                      onChange={hanldeChangeClXbar}
                      label="CL"
                      type="number"
                      onWheel={(event) => event.target.blur()}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                  <div className="m-1">
                    <TextField
                      disabled={!isSC}
                      value={LCL_Xbar}
                      onChange={handleChnageLclXbar}
                      label="LCL"
                      type="number"
                      onWheel={(event) => event.target.blur()}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                </div>
              </div>

              <div className="flex flex-col mt-2">
                <span className="mt-2 font-semibold">R-chart</span>
                <div className="flex flex-row">
                  <div className="m-1">
                    <TextField
                      disabled={!isSC}
                      value={UCL_Rchart}
                      onChange={hanldeChangeUclRchart}
                      label="UCL"
                      type="number"
                      onWheel={(event) => event.target.blur()}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                  <div className="m-1">
                    <TextField
                      disabled={!isSC}
                      value={CL_Rchart}
                      onChange={hanldeChangeClRchart}
                      label="CL"
                      type="number"
                      onWheel={(event) => event.target.blur()}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                  <div className="m-1">
                    <TextField
                      value={LCL_Rchart}
                      onChange={handleChangeLclRchart}
                      label="LCL"
                      type="number"
                      disabled={!isSC}
                      onWheel={(event) => event.target.blur()}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Box>
          <Formula
            partID={partId}
            formula={formula}
            setFormula={setFormula}
            setChangeData={() => {}}
          />
        </DialogContent>
      </Box>
      <DialogActions>
        <Button
          color="success"
          disabled={errorMinMax}
          autoFocus
          variant="contained"
          onClick={() => {
            createQuestion(
              imageQuestion.file,
              specMin,
              specMax,
              // switchRef.current.value,
              isSC,
              question,
              remark,
              inspectionTool,
              UCL_Xbar,
              CL_Xbar,
              LCL_Xbar,
              UCL_Rchart,
              CL_Rchart,
              LCL_Rchart,
              subCat,
              formula
            );
          }}
        >
          บันทึก
        </Button>
      </DialogActions>
      {openAddTemplate && (
        <AddTemplate
          open={openAddTemplate}
          setOpen={setOpenAddTemplate}
          setSuccess={setSuccess}
        />
      )}
      {openEditTemplate && (
        <TemplateEdit
          subCat={template && template.id ? parseInt(template.id) : ""}
          open={openEditTemplate}
          setOpen={setOpenEditTemplate}
          setSuccess={setSuccess}
          templateData={template}
          onUpdate={handleRefetch}
        />
      )}
    </BootstrapDialog>
  );
}

export default FormAddQuestionTemplate;
